module.exports = __webpack_public_path__ + "static/media/Paul Cannavan.8f2b7f40.jpeg";